module.exports = __webpack_public_path__ + "static/media/bg4.9f6f1742.webp";